// Phase 36 Batch R — Country flag utility.
//
// Convert an ISO 3166-1 alpha-2 country code into a Unicode flag
// emoji via regional indicator code points. No external data, no
// network — every modern OS renders these natively.

export function flagEmoji(iso2) {
  if (!iso2 || typeof iso2 !== "string" || iso2.length !== 2) return "";
  const upper = iso2.toUpperCase();
  const A = 0x1F1E6;
  const a = "A".charCodeAt(0);
  return String.fromCodePoint(A + upper.charCodeAt(0) - a, A + upper.charCodeAt(1) - a);
}

// Resolve a deal/property's effective country code. Reads both the
// Batch-R authoritative `country_iso2` and the legacy `country` field
// (which historically held the same 2-letter code for US, plus a few
// non-canonical values for older non-US data).
export function countryOf(propertyOrDeal) {
  if (!propertyOrDeal) return "US";
  const p = propertyOrDeal.property || propertyOrDeal;
  return (p?.country_iso2 || p?.country || "US").toUpperCase();
}

// Render-helper: "🇺🇸 FL" or "🇨🇦 ON" with the flag + region short
// code separated by a space.
export function flagWithRegion(propertyOrDeal) {
  if (!propertyOrDeal) return "";
  const p = propertyOrDeal.property || propertyOrDeal;
  const flag = flagEmoji(countryOf(propertyOrDeal));
  const region = p?.region_code || p?.state || "";
  return region ? `${flag} ${region}` : flag;
}
